module.exports = __webpack_public_path__ + "img/phototype.de8aca15.png";